// @ts-nocheck
import React from "react";
import { styled } from '@mui/material/styles';
import { useLocation } from "react-router-dom";
import {Typography, Button} from '@mui/material'
import Home from '@mui/icons-material/Home'
import Error from "@mui/icons-material/Error"

const PREFIX = 'Page500';

const classes = {
  icon: `${PREFIX}-icon`,
  container: `${PREFIX}-container`,
  message: `${PREFIX}-message`,
  paper: `${PREFIX}-paper`,
  button: `${PREFIX}-button`,
  details: `${PREFIX}-details`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.icon}`]: {
    width: 200,
    height: 200,
    color: theme.palette.secondary.main,
    margin: theme.spacing(2)
  },

  [`& .${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: `100%`,
    overflowY:"auto"
  },

  [`& .${classes.message}`]: {
     margin: theme.spacing(1)
  },

  [`& .${classes.paper}`]: {
    backgroundColor: theme.palette.background.default,
    marginTop: theme.spacing(4),
    maxWidth: 700
    //height: `calc(100vh - 64px)`,
  },

  [`& .${classes.button}`]: {
    margin: 20,
  },

  [`& .${classes.details}`]: {
    padding: theme.spacing(2),
    width: "100%"
  }
}));

export const Page500 = (props) => {

  const location = useLocation();

  const currentError = props.error||location?.state;

  if(currentError && !currentError.data  && currentError.body?.startsWith("{"))
  {
    try
    {
    currentError.data = JSON.parse(currentError.body);
    }
    catch(e)
    {
        currentError.message = e.message;
        currentError.stack = e.stack; 
    }
  }

  console.log("Error: " + JSON.stringify(currentError));

  return(
    <div class='form'>
    <Root>
         <div className={classes.paper}>
          <div className={classes.container}>
            <Typography variant="h4">Oops... an unexpected error has occured.</Typography>
            <Typography variant="subtitle1">
              <div><Error color='primary' sx={{height:64,width:64}}></Error></div>

              </Typography>
            <Typography variant="subtitle1" className={classes.message}>
            <div>{currentError?.data?.message || currentError?.message || currentError?.type}</div>
          </Typography>

          <Button
              color="secondary"
              aria-label="home"
              href="/"
              className={classes.button}
            >
              <Home />
            </Button>

            <Typography variant="subtitle1" className={classes.message}>
                Please try again or contact the Service Desk for assistance.
            </Typography>
          
      
                      
          </div>
        </div>         
    </Root></div>);
  }

export default Page500;
